module.exports = __webpack_public_path__ + "img/vk.f28195a2.png";